import { useQuery } from "@tanstack/react-query"
import type { InvitationListResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function usePropertyInvitations(propertyId: string | undefined) {
	return useQuery({
		queryKey: propertyId
			? queryKeys.propertyInvitations(propertyId)
			: ["properties", "__nil__", "invitations"],
		queryFn: () =>
			apiFetch<InvitationListResponse>(
				`/api/common/properties/${propertyId}/invitations`,
			),
		enabled: !!propertyId,
	})
}
